import {
  ARBRE_FIELDS,
  ARBRE_SECTIONS,
  DEFAULT_ARBRE_TEMPLATE,
  HtmlPrintTemplate,
  type PrintFieldDef,
  type PrintSectionDef,
} from "@repo/print-pdf/arbre/print/template";
import {
  DEFAULT_EPAYSAGE_TEMPLATE,
  EPAYSAGE_FIELDS,
  EPAYSAGE_SECTIONS,
  HtmlEpaysageTemplate,
} from "@repo/print-pdf/epaysage/template";
import type { PrintInventoryType, PrintTemplate } from "@repo/types";
import type { ReactElement, ReactNode } from "react";
import { SAMPLE_PRINT_DATA } from "./sample-data";
import { SAMPLE_EPAYSAGE_DATA } from "./sample-data-epaysage";

export type EditorVariantKey = Extract<
  PrintInventoryType,
  "ARBRE" | "EPAYSAGE"
>;

export interface EditorVariant {
  label: string;
  description: string;
  sections: PrintSectionDef[];
  fields: PrintFieldDef<any>[];
  defaultTemplate: PrintTemplate;
  /** Aperçu HTML (blocs riches en cadres pointillés). */
  preview: (template: PrintTemplate) => ReactNode;
  /** Pages PDF d'exemple ; react-pdf et le peintre PDF ne sont chargés qu'au premier clic. */
  loadPdfPages: () => Promise<(template: PrintTemplate) => ReactElement>;
  pdfFilename: string;
  /** Couleur de la barre de titre de la fiche actuelle (affichée tant que le modèle n'en choisit pas). */
  titleBg: string;
}

export const EDITOR_VARIANTS: Record<EditorVariantKey, EditorVariant> = {
  ARBRE: {
    label: "Arbre",
    description: "Fiche de synthèse arbre",
    sections: ARBRE_SECTIONS,
    fields: ARBRE_FIELDS,
    defaultTemplate: DEFAULT_ARBRE_TEMPLATE,
    preview: (template) => (
      <HtmlPrintTemplate
        template={template}
        data={SAMPLE_PRINT_DATA}
        inventaireId={1}
      />
    ),
    loadPdfPages: async () => {
      const { PdfPrintTemplate } =
        await import("@repo/print-pdf/arbre/pdf/template");
      return (template) => (
        <PdfPrintTemplate
          template={template}
          data={SAMPLE_PRINT_DATA}
          inventaireId={1}
        />
      );
    },
    pdfFilename: "fiche-arbre-apercu.pdf",
    titleBg: "#02BC77",
  },
  EPAYSAGE: {
    label: "Espace boisé",
    description:
      "Fiche de l'espace boisé : synthèse puis une page par essence (page d'impression, PDF et impression multiple)",
    sections: EPAYSAGE_SECTIONS,
    fields: EPAYSAGE_FIELDS,
    defaultTemplate: DEFAULT_EPAYSAGE_TEMPLATE,
    preview: (template) => (
      <HtmlEpaysageTemplate
        template={template}
        data={SAMPLE_EPAYSAGE_DATA}
        inventaireId={1}
      />
    ),
    loadPdfPages: async () => {
      const { PdfEpaysageTemplate } =
        await import("@repo/print-pdf/epaysage/pdf-template");
      return (template) => (
        <PdfEpaysageTemplate
          template={template}
          data={SAMPLE_EPAYSAGE_DATA}
          inventaireId={1}
        />
      );
    },
    pdfFilename: "fiche-espace-boise-apercu.pdf",
    titleBg: "#964B00",
  },
};

export const EDITOR_VARIANT_KEYS = Object.keys(
  EDITOR_VARIANTS,
) as EditorVariantKey[];
